import Swiper, { Navigation, A11y } from 'swiper';

export default () => {
	const gridResults = document.querySelector(
		'#results-slider .grid-results .swiper-wrapper'
	);
	if (gridResults) {
		const gridResultsAmount = gridResults.dataset.totalResults;
		// results slider
		const resultsSwiper = new Swiper('#results-slider .grid-results', {
			modules: [Navigation, A11y],
			navigation: {
				nextEl: '#results-slider .arrow-next',
				prevEl: '#results-slider .arrow-prev',
			},
			a11y: true,
			keyboardControl: true,
			grabCursor: true,
			watchOverflow: true,
			loop: true,
			watchSlidesProgress: true,
			breakpoints: {
				320: {
					slidesPerView: 1,
					slidesPerGroup: 1,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 40,
					slidesPerGroup: 2,
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 40,
					slidesPerGroup: 3,
				},
				1200: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 35,
					loop: gridResultsAmount > 4,
				},
			},
			on: {
				slideChange: () => updateLastItem(gridResults),
				resize: function () {
					this.update();
					this.updateSlidesClasses();
					this.updateSlides();
					updateLastItem(gridResults);
				},
			}, 
		});
	}

	updateLastItem(gridResults);

	//listen for browser size changes
	window.onresize = function () {
		resultsSwiper.update();
	};

};

function updateLastItem(parentGrid = null) {
	if (parentGrid) {
		// Clean last element class
		removeCurrentLastClass(parentGrid);
		const visibleSlides = parentGrid.querySelectorAll('.swiper-slide-visible');
		const lastVisibleSlide = visibleSlides[visibleSlides.length - 1];
		lastVisibleSlide.classList.add('last-slide-in-viewport');
	}
}

function removeCurrentLastClass(parentGrid) {
	const currentLastVisibleSlide = parentGrid.querySelector(
		'.last-slide-in-viewport'
	);
	currentLastVisibleSlide
		? currentLastVisibleSlide.classList.remove('last-slide-in-viewport')
		: '';
}